



// // components/PDFDownload.js
// import { jsPDF } from 'jspdf';
// import autoTable from 'jspdf-autotable';
// const PDFDownload = ({ headers, rows, filename = 'download.pdf' }) => {
//   const handleDownload = () => {
//     const doc = new jsPDF('p', 'mm', 'a4');

//     // Add a title
//     doc.setFontSize(16);
//     doc.setFont('helvetica', 'bold');
//     doc.text('Serco Report', doc.internal.pageSize.width / 2, 20, { align: 'center' });

//     // Add subtitle or meta information
//     doc.setFontSize(10);
//     doc.setFont('helvetica', 'normal');
//     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 10, 30);

//     // Prepare table headers and rows for autoTable
    
//     const tableHeaders = headers.map(header => header.label);
//     const tableRows = rows.map(row => headers.map(header => row[header.key]?.toString() || ''));

//     // Add table using autoTable
//     autoTable(doc, {
//       head: [tableHeaders],
//       body: tableRows,
//       startY: 40, // Position table below title
//       margin: { left: 10, right: 10 },
//       styles: {
//         fontSize: 8, // Smaller font for compact display
//         cellPadding: 2,
//         valign: 'middle',
//         overflow: 'linebreak', // Ensures text wrapping
//       },
//       headStyles: {
//         fillColor: [37, 99, 235], // Blue header background
//         textColor: 255, // White text
//         fontStyle: 'bold',
//       },
//       columnStyles: { 0: { cellWidth: 25 }, default: { cellWidth: 25 } },

//       alternateRowStyles: {
//         fillColor: [240, 240, 240], // Light gray alternate rows
//       },
//     });

//     // Save the PDF
//     doc.save(filename);
//   };

//   handleDownload();

//   return null; // No UI needed since the download is triggered automatically
// };

// export default PDFDownload;




// components/PDFDownload.js
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const PDFDownload = ({ headers, rows, filename = 'download.pdf' },Name='DeviceName') => {
  const handleDownload = () => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Add a title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Serco Report`, doc.internal.pageSize.width / 2, 20, { align: 'center' });

    // Add subtitle or meta information
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 10, 30);

    // Add S.No. column to headers
    const extendedHeaders = [{ label: 'S.No.', key: 'sno' }, ...headers];
    const tableHeaders = extendedHeaders.map(header => header.label);

    // Add S.No. column to rows
    const extendedRows = rows.map((row, index) => ({
      sno: (index + 1).toString(), // Generate serial numbers
      ...row,
    }));
    // const tableRows = extendedRows.map(row =>
    //   extendedHeaders.map(header => row[header.key]?.toString() || '')
    // );


    const tableRows = extendedRows.map(row =>
      extendedHeaders.map(header => {
        // Safely access nested properties and handle missing values
        const keys = header.key.split('.');
        let value = row;
        for (const key of keys) {
          value = value?.[key];
          if (value === undefined || value === '' || value === null) {
            return 'Not Available';
          }
        }
        return value?.toString() || 'Not Available';
      })
    );
    

    // Add table using autoTable
    autoTable(doc, {
      head: [tableHeaders],
      body: tableRows,
      startY: 40, // Position table below title
      margin: { left: 10, right: 10 },
      styles: {
        fontSize: 8, // Smaller font for compact display
        cellPadding: 2,
        valign: 'middle',
        overflow: 'linebreak', // Ensures text wrapping
        lineWidth: 0.1, // Border thickness
        lineColor: [0, 0, 0], // Border color (black)
      },
      headStyles: {
        fillColor: [37, 99, 235], // Blue header background
        textColor: 255, // White text
        fontStyle: 'bold',
        lineColor: [37, 99, 235], // Border color (black)
      },
      columnStyles: {
        0: { cellWidth: 15 }, // Narrower column for S.No.
        default: { cellWidth: 25 }, // Other columns default to 25px
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray alternate rows
      },
    });

    // Save the PDF
    doc.save(filename);
  };

  handleDownload();

  return null; // No UI needed since the download is triggered automatically
};

export default PDFDownload;
